export const PACKAGE_NAME = 'jira-issue-table-hierarchy';
export const TEAM_NAME = 'keystone';
